import { render, staticRenderFns } from "./BannedSendingIPs.vue?vue&type=template&id=256cf2e0&"
import script from "./BannedSendingIPs.vue?vue&type=script&lang=js&"
export * from "./BannedSendingIPs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports